import { useEffect, useState } from 'react'

type Countdown = {
  label: string
  expired: boolean
}

function pad(value: number): string {
  return value.toString().padStart(2, '0')
}

export function useCountdown(totalSeconds: number): Countdown {
  const [remaining, setRemaining] = useState(totalSeconds)

  useEffect(() => {
    if (remaining <= 0) return
    const id = window.setInterval(() => {
      setRemaining((prev) => (prev <= 1 ? 0 : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [remaining])

  const hours = Math.floor(remaining / 3600)
  const minutes = Math.floor((remaining % 3600) / 60)
  const seconds = remaining % 60

  return {
    label: `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`,
    expired: remaining <= 0,
  }
}
